// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"33":"d066efc0","48":"f4526b0e","113":"b67e8779","229":"fea62917","265":"435ed36f","354":"1b31c915","369":"b25ab9ba","370":"9d6237be","408":"9c76e940","488":"c952dfe0","764":"d4a7cf6a","793":"afcd0498"}[chunkId] + ".chunk.js";
};